export default "__VITE_ASSET__DFgf98nu__"